import { render, staticRenderFns } from "./Promociones.vue?vue&type=template&id=7b955891&scoped=true"
import script from "./Promociones.vue?vue&type=script&lang=js"
export * from "./Promociones.vue?vue&type=script&lang=js"
import style0 from "./Promociones.vue?vue&type=style&index=0&id=7b955891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b955891",
  null
  
)

export default component.exports